import React from "react";

export default function AssetPreviewModal({
  assetsModal,
  onClose,
  onDownload,
}) {
  if (!assetsModal?.show) {
    return null;
  }

  return (
    <div className="messaging__popup">
      <div className="messaging__popup-header">
        <div className="download" onClick={() => onDownload(assetsModal?.full_path)}>
          <img src="/assets/icons/download.svg" alt="" />
        </div>
        <div className="close" onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6L18 18M6 18L18 6L6 18Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      <div className="messaging__popup-content">
        {assetsModal?.type === "image" ? (
          <div>
            <img src={assetsModal?.full_path} alt="" />
          </div>
        ) : assetsModal?.type === "video" ? (
          <video width="320" height="240" controls>
            <source src={assetsModal?.full_path} type="video/mp4" />
          </video>
        ) : (
          <div></div>
        )}
      </div>
      <div></div>
      <div className="messaging__popup-bg" onClick={onClose}></div>
    </div>
  );
}
